<template>
  <div>
    <nav
      id="nav-menu"
      class="fixed-bottom py-0 d-flex justify-content-around mt-2"
      style="background: rgb(162, 162, 162); overflow-x: auto; white-space: nowrap"
    >
      <!-- <div
        :style="mtdGetStyle('pharmacy')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('pharmacy')"
      >
        <span :style="mtdGetStyleSpan('pharmacy')" class="btn w-100"
          ><strong>FARMACIA</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('rehabilitation')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('rehabilitation')"
      >
        <span :style="mtdGetStyleSpan('rehabilitation')" class="btn w-100"
          ><strong>REHABILITACIÓN</strong></span
        >
      </div> -->
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavBarComponent",
  props: {
    pageView: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      page: null,
    };
  },
  created() {},
  methods: {
    mtdGetStyle: function (option) {
      if (option == this.page && this.pageView != "home" && this.pageView != "close")
        return "background: #2f395c";
      return "";
    },
    mtdGetStyleSpan: function (option) {
      if (option == this.page && this.pageView !== "home" && this.pageView !== "close")
        return "color:white";
      return "text-dark";
    },
    mtdSendOption: function (page) {
      this.page = page;
      this.$emit("changePage", this.page);
    },
  },
};
</script>